import styled from "styled-components";
import { Button, Grid } from "@material-ui/core";

export const STButton = styled(Button)`
  && {
    text-transform: none;
    margin-top: 24px;
  }
`;

export const STText = styled.span`
  && {
    padding-left: 8px;
  }
`;

export const STGrid = styled(Grid)`
  && {
    width: 500px;
  }
`;
